import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsalert',
	templateUrl:'./BSAlertPage.html',
	styles: [],
	styleUrls:['./BSAlertPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSAlertPage
{
	mdContent_57 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.alerts.BSAlert;
\`\`\``;
	mdContent_58 = `\`\`\`java
new BSAlert<>()
\`\`\``;
	mdContent_59 = `\`\`\`java
new BSAlertDanger<>()
\`\`\``;
	mdContent_60 = `\`\`\`java
new BSAlertSuccess<>()
\`\`\``;
	mdContent_61 = `\`\`\`java
var alert = new BSAlertDanger<>();
alert.setText("Something went wrong!");
\`\`\``;
}
